function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.923 18.382a1.001 1.001 0 00-.216-1.09l-3-3a1 1 0 00-1.414 1.415L20.586 17H15a1 1 0 000 2h5.586l-1.293 1.293a.999.999 0 101.414 1.414l3-3c.092-.092.165-.202.216-.325M12 12.67L3.25 5h17.5L12 12.67zM22 12a1 1 0 002 0V6c0-1.654-1.346-3-3-3H3C1.346 3 0 4.346 0 6v12c0 1.654 1.346 3 3 3h8a1 1 0 000-2H3c-.551 0-1-.45-1-1V6.564l9.341 8.188A.993.993 0 0012 15a.993.993 0 00.659-.248L22 6.564V12z"
});

var SvgIconMailSend = function SvgIconMailSend(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgIconMailSend;